/**
 * Show only possible term combinations for Color or Image Variation Swatches for WooCommerce Pro.
 *
 * @version   1.2.3
 * @since     1.0.0
 * @requires  jQuery.js
 */

/**
 * Sets up the "show only possible term combinations" feature.
 *
 * @since   1.2.3
 * @version 1.2.3
 *
 * @param {Object} alg_wc_civs The free version swatches object.
 */
export default function showOnlyPossibleTermCombinations( alg_wc_civs ) {
	var $ = jQuery;

	var alg_wc_civs_soptc = {
		term_selector: null,
		original_select_selector: null,

		/**
		 * Initiate.
		 */
		init: function () {
			var term_str = this.term_selector;
			var select_str = this.original_select_selector;

			$('body').on('change', select_str, function () {
				$(term_str).each(function () {
					var current_data_attribute = jQuery(this).parent().attr('data-attribute');
					var term_value = jQuery(this).attr('data-value');
					var correspondent_select = $(select_str).filter('[id="' + current_data_attribute + '"]');
					var correspondent_option = correspondent_select.find('option[value="' + term_value + '"]');
					if (!correspondent_option.length) {
						jQuery(this).addClass('disabled');
					} else {
						jQuery(this).removeClass('disabled');
					}
				})
			})
		}
	};

	window.alg_wc_civs_soptc = alg_wc_civs_soptc;
	alg_wc_civs_soptc.term_selector = alg_wc_civs.term_selector;
	alg_wc_civs_soptc.original_select_selector = alg_wc_civs.original_select_selector;
	alg_wc_civs_soptc.init();
}
